module.exports = __webpack_public_path__ + "static/media/tmdb.4906bce9.svg";